<template>
  <div class="deduct_house">
    <template-form
      title="ค่าลดหย่อนต่างๆ"
      description="กรอกค่าลดหย่อนต่างๆที่คุณใช้สิทธิ์"
    >
      <div class="dhb-detail">
        <h4>ที่อยู่อาศัย</h4>
      </div>

      <div class="dhb-answer">
        <div class="dhba-caption">
          ดอกเบี้ยบ้าน <span>(สูงสุด ฿100,000)</span>
        </div>
        <currency v-model="houseInterest" v-on:change="setHouseInterest" />
      </div>

      <div class="dhb-answer">
        <div class="dhba-caption">
          บ้านหลังแรก
        </div>
        <currency v-model="firstHouse" v-on:change="setFirstHouse" />
      </div>

      <div class="dhb-footer">
        <back-button caption="ก่อนหน้า" />
        <chevron-right-link @clickLink="goNext" caption="ถัดไป" />
      </div>
    </template-form>

    <div class="dh-loading">
      <div class="dhl-active" />
    </div>
    <StateAnswer />
  </div>
</template>

<script>
import StateAnswer from "@/components/StateAnswer.vue";

export default {
  name: "DeductHouse",
  components: {
    StateAnswer,
  },
  data() {
    const houseInterest = this.$store.getters["taxInfo/getDeduct"]
      .houseInterest;
    const firstHouse = this.$store.getters["taxInfo/getDeduct"].firstHouse;
    return {
      houseInterest,
      firstHouse,
    };
  },
  methods: {
    // goBack() {
    //   this.$router.push({ path: "/forms/deduct_personal" });
    // },
    goNext() {
      this.$router.push({ path: "/forms/deduct_investment" });
    },
    setHouseInterest(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "houseInterest",
        value: value,
      });
    },
    setFirstHouse(value) {
      this.$store.dispatch("taxInfo/addDeductValue", {
        name: "firstHouse",
        value: value,
      });
    },
  },
  computed: {},
};
</script>

<style scoped>
.deduct_house {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 34px;
  box-sizing: border-box;
  /* justify-content: space-between; */
}

.dhb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 16px;
  max-width: 352px;
  text-align: left;
}

.dhb-answer {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  max-width: 352px;
}
.dhba-caption {
  display: flex;
}
.dhba-caption > span {
  color: #acb1bf;
  margin-left: 6px;
}
.dhb-footer {
  margin-top: 24px;
  margin-bottom: 31px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 352px;
}
.dhb-footer .crl-link {
  justify-content: flex-end;
}

.dh-loading {
  width: 100%;
  height: 8px;
  background: #e6e8ec;
  position: relative;
}
.dhl-active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 50%;
  height: 100%;
  background: #008fc1;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .deduct_house {
    padding-top: 50px;
  }

  .dhb-detail {
    max-width: 514px;
    text-align: center;
    white-space: nowrap;
    margin-bottom: 28px;
  }
}
</style>
